export const API_BASE_URL = 'http://localhost:8000/';